import React from "react";
import LoginBanner from "../../assets/LoginBanner.webp";

const LoginPageLeft = () => {
  return (
    <div className="flex item-center">
      <img
        alt="login-banner"
        src={LoginBanner}
        className="md:h-auto rounded-2xl hidden md:block relative md:top-0 top-[130px]"
        loading="lazy"
      />
    </div>
  );
};

export default LoginPageLeft;
